import { styled } from '@mui/material/styles';

export const StyledBackground = styled('div', { shouldForwardProp: prop => prop !== 'isHeader' })<{
  isHeader?: boolean;
}>`
  background: ${({ theme }) => theme.palette.secondary.main};
  color: ${({ theme }) => theme.palette.primary.contrastText};
  padding: ${({ theme }) => theme.spacing(3, 4)};
  display: flex;
  flex-direction: column;
  min-height: ${({ isHeader }) => (isHeader ? '25vh' : '100vh')};
  position: relative;
`;
